import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BotonesComponent } from './botones/botones.component';
import { InputComponent } from './input/input.component';
import { ThemeModule } from '../@core/theme.module';
import { AppRoutingModule } from '../app.routing.module';
import { InicioComponent } from './inicio/inicio.component';
import { IconosComponent } from './iconos/iconos.component';
import { CarouselComponent } from './carousel/carousel.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { DesplegablesComponent } from './desplegables/desplegables.component';
import { EtiquetasComponent } from './etiquetas/etiquetas.component';
import { FormularioComponent } from './formulario/formulario.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { ModalDocComponent } from './modal-doc/modal-doc.component';
import { NotificacionesComponent } from './notificaciones/notificaciones.component';
import { PaginacionComponent } from './paginacion/paginacion.component';
import { RadiobuttonsComponent } from './radiobuttons/radiobuttons.component';
import { TablaComponent } from './tabla/tabla.component';
import { ScrollComponent } from './scroll/scroll.component';
import { CollapseComponent } from './collapse/collapse.component';
import { TecladoComponent } from './teclado/teclado.component';
import { TextareaComponent } from './textarea/textarea.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { AlertasComponent } from './alertas/alertas.component';
import { TabsComponent } from './tabs/tabs.component';
import { PagesRoutingModule } from './pages.routing.module';
import { PagesComponent } from './pages.component';
import { HeaderDocComponent } from './header-doc/header-doc.component';
import { FooterDocComponent } from './footer-doc/footer-doc.component';
import { BarraAccesibilidadDocComponent } from './barra-accesibilidad-doc/barra-accesibilidad-doc.component';
import { RouterModule } from '@angular/router';
import { utils } from './../../assets/js/utils.js';
import { ColoresComponent } from './colores/colores.component';
import { TipografiaComponent } from './tipografia/tipografia.component';
import { BackToTopDocComponent } from './back-to-top-doc/back-to-top-doc.component';
import { CalendarioComponent } from './calendario/calendario.component';
import { InicioSesionComponent } from './inicio-sesion/inicio-sesion.component';
import { ContadorComponent } from './contador/contador.component';
import { EmbebidosComponent } from './embebidos/embebidos.component';
import { CardsComponent } from './cards/cards.component';
import { EspaciadosComponent } from './espaciados/espaciados.component';
import { VisualizacionArchivosComponent } from './visualizacion-archivos/visualizacion-archivos.component';
import { ContenedorImagenesComponent } from './contenedor-imagenes/contenedor-imagenes.component';
import { ModalComponent } from './modal/modal.component';
import { TransversalesModule } from './transversales/transversales.module';
import { InputFileComponent } from './input-file/input-file.component';

@NgModule({
  declarations: [
    PagesComponent,
    BotonesComponent,
    InputComponent,
    InicioComponent,
    IconosComponent,
    CarouselComponent,
    CheckboxComponent,
    DesplegablesComponent,
    EtiquetasComponent,
    FormularioComponent,
    BreadcrumbComponent,
    ModalDocComponent,
    NotificacionesComponent,
    PaginacionComponent,
    RadiobuttonsComponent,
    TablaComponent,
    ScrollComponent,
    CollapseComponent,
    TecladoComponent,
    TextareaComponent,
    TooltipComponent,
    AlertasComponent,
    TabsComponent,
    HeaderDocComponent,
    FooterDocComponent,
    BarraAccesibilidadDocComponent,
    ColoresComponent,
    TipografiaComponent,
    BackToTopDocComponent,
    CalendarioComponent,
    InicioSesionComponent,
    ContadorComponent,
    EmbebidosComponent,
    CardsComponent,
    EspaciadosComponent,
    VisualizacionArchivosComponent,
    ContenedorImagenesComponent,
    ModalComponent,
    InputFileComponent],
  imports: [
    RouterModule,
    PagesRoutingModule,
    TransversalesModule,
    CommonModule,
    ThemeModule,
    AppRoutingModule,
  ],
  providers: [],
  bootstrap: [PagesComponent],
  entryComponents: [],
  exports: [BotonesComponent, InputComponent, ModalComponent],
})
export class PagesModule { }
